<template>
<!-- 征稿函预览 -->
  <div class="fillingPreview">
    <p v-show="state" class="invalid">该页面为预览效果，短期内将会失效</p>
    <div  v-if="state" class="content">
      <div class="lift">
        <p>
          <img src="@/assets/img/details/2.png" alt="">
          <span>收藏</span>
        </p>
        <p>
          <img src="@/assets/img/details/onlineReading.png" alt="">
          <span>在线投稿</span>
        </p>
        <p>
          <img src="@/assets/img/details/share.png" alt="">
          <span>分享</span>
        </p>
      </div>
      <div class="centre">
        <p class="h" v-html="previewList.title">{{previewList.title}}</p>
        <p class="source">
          <span >来源：{{previewList.perName}}</span>
          <!-- <span style="margin-left:10px;" v-if="previewList.createTime">{{previewList.createTime.slice(0,10)}}</span> -->
        </p>
        <div class="details">
          <p v-html="previewList.content"></p>
        </div>
      </div>
      <div>
        <div class="right">
          <p class="right-1">期刊</p>
          <p class="right-2">
            <img v-lazy="`${$global.imgUrl}${user.headImg}`" alt="">
            <span>{{previewList.perName}}</span>
          </p>
          <div class="right-3">
            <span class="wx">
              <span style="fontSize:18px;color:#ff7d14">0</span>
              <span>文献数</span>
            </span>
            <span class="zx">
              <span style="fontSize:18px;color:#ff7d14">0</span>
              <span>资讯数</span>
            </span>
          </div>
        </div>
          <div class="right2">
            <div class="h">最新资讯</div>
            <div class="list">
              <ul>
                <li v-for="item in wenxian" :key="item.id">
                 <span v-html="item.title">{{item.title}}</span> 
                </li>
              </ul>
            </div>
          </div>
      </div>
    </div>
    <div v-else class="images">
      <img src="@/assets/img/details/urlDisabled.png" alt="">
      <div>临时链接已失效</div>
    </div>
  </div>
</template>

<script>
export default {
     name:'fillingPreview',
    components: {

    },
    props: {

    },
    data() {
        return {
          previewList:{},
          wenxian:{},
          user:{},
          state:true
        };
    },
    computed: {

    },
    watch: {

    },
    created() {
     this.setPreview()

    },
    mounted() {

    },
    methods: {
      // 获取预览详情
          async setPreview(){
        const resp = await this.$apis.userServe.articlePreview({
        articleId: this.$route.query.articleId
        });
        if(resp.resultCode == 200 ) {
          this.previewList = resp.data
          this.getwenxian()
          this.getAuthor()
        }else{
        this.state = false
      }       
      },
      // 获取最新资讯
      async getwenxian(){
      let obj = {
        companyId: this.previewList.perId,
        pageNo: 1,
        pageSize: 5,
      };
        const { data } = await this.$apis.recomendServe.getwenxian(obj)
          this.wenxian = data.list
          console.log(this.wenxian)
      },
    // 获取发布者信息
    async getAuthor(){
      const resp = await this.$apis.recomendServe.getAuthor({
        userId:this.previewList.createUser,
        type:1
      })
      if(resp.resultCode == 200){
        this.user = resp.content
      }
    },
    },
};
</script>

<style scoped lang="scss">
.fillingPreview{
  .invalid{
    margin: 0 auto 50px;
    text-align: center;
    width: 396px;
    height: 45px;
    line-height: 45px;
    background: #f9f9f9;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
  }
  .images{
    text-align: center;
    position: relative;
    top: 50px;
    margin-top: 50px;
    & img{
      margin-bottom: 50px;
    }
  }
  .content{
    display: flex;
    justify-content: center;
    .lift{
      margin-right: 40px;
      font-size: 13px;
      p{
        margin-bottom:44px;
        display: flex;
        flex-direction:column;
        text-align: center;
        
      }
      p img{
        margin-left: 16px;
        width: 28px;
        height: 28px;
      }
      p span{
          width: 60px !important;
      }
    }
    .centre{
      width: 905px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      padding: 43px 25px;
      .h{
        font-size: 30px;
        font-weight: bold;
        line-height: 48px;
        color: #263d78;
      }
      .source{
        margin: 15px 0;
      }
        .details{
            font-size: 16px;
            line-height: 30px;
            }
    }
    .right{
      width: 270px;
      height: 250px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .right-1{
        margin: 25px 0 0 20px;
      }
      .right-2{
        text-align: center;
        img{
          width: 84px;
          height: 84px;
          border-radius: 50px;
        }
        span{
          display: block;
          color: #333333;
          font-weight: bold;
          font-size: 18px;
          margin-top: 15px;
        }
      }
      .right-3{
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        font-size: 12px;
        .wx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
        .zx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
      }
    }
    .right2{
      width: 270px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .h{
        font-size: 18px;
        color: #333;
        padding: 20px 25px;
        font-weight: bold;
        border-bottom: 1px solid #e5e5e5;
      }
      .list{
        ul li{
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          padding-bottom: 20px;
          color: #666;
          border-bottom: 1px dashed #e8e8e8;
          font-size: 12px;
        }
        ul :nth-last-child(1){
          border-bottom: none;
        }
      }
    }
  }
}

</style>
